import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCarMechanic,
  faExclamationTriangle,
} from '@fortawesome/pro-duotone-svg-icons';


library.add(
  faCarMechanic,
  faExclamationTriangle,
);
